import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface RangeFeedbackDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Dialog component that displays a thank you message after successful feedback submission.
 * Shows when a user submits feedback about needing a wider design window range.
 */
export const RangeFeedbackDialog: React.FC<RangeFeedbackDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircleOutlineIcon color="success" fontSize="large" />
          <Typography variant="h5" component="span">
            Thank You!
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" paragraph>
          Thank you for your feedback. We have recorded your request for a wider design window 
          and will review it for future implementations.
        </Typography>
        
        <Typography variant="body2" color="text.secondary">
          Your input helps us improve the AI Design Wizard to better serve your needs.
        </Typography>
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="primary"
          fullWidth
          sx={{ margin: 2 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

